// extracted by mini-css-extract-plugin
export default {"container":"styles__container___YJjNx","initials":"styles__initials___sePvS","photoIcon":"styles__photoIcon___q1p6t"};